import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const AdminContext = createContext(null);

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AdminProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    checkAdminAuth();
  }, [user]);

  const checkAdminAuth = async () => {
    const adminToken = localStorage.getItem('admin_session_token');
    const userToken = localStorage.getItem('session_token');
    const tokens = [adminToken, userToken].filter(Boolean);

    if (tokens.length === 0) {
      setLoading(false);
      return;
    }

    for (const token of tokens) {
      try {
        const response = await axios.get(`${API}/admin/me`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setAdmin(response.data);
        setLoading(false);
        return;
      } catch (error) {
        // Try next token
      }
    }

    localStorage.removeItem('admin_session_token');
    setAdmin(null);
    setLoading(false);
  };

  const login = async (email, password) => {
    try {
      const response = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem('admin_session_token', response.data.session_token);
      setAdmin(response.data.admin);
      return { success: true };
    } catch (error) {
      return { success: false, error: error.response?.data?.detail || 'Login failed' };
    }
  };

  const logout = async () => {
    try {
      const sessionToken = localStorage.getItem('admin_session_token');
      if (sessionToken) {
        await axios.post(`${API}/admin/logout`, {}, {
          headers: { Authorization: `Bearer ${sessionToken}` }
        });
      }
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('admin_session_token');
      setAdmin(null);
    }
  };

  const value = {
    admin,
    loading,
    login,
    logout,
    checkAdminAuth
  };

  return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
};

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within AdminProvider');
  }
  return context;
};
